/** Typografische streepjes uit Word/Outlook/e-mail → gewoon minteken (-). */
const TYPOGRAPHIC_DASHES = /[\u2010-\u2015\u2212\uFE58\uFE63\uFF0D]/g;

export function normalizeEmailDashes(email: string): string {
  return email.replace(TYPOGRAPHIC_DASHES, "-");
}
